<template>
    <div class="searchfieldholder">
<!-- @keyup="emitUpdate" -->
        <input :class="{ active: isSearchfieldActive }" v-model="searchfieldValue"  type="text" name="searchfield" class="searchfield" placeholder="Zoek...">
        <img v-if="isSearchfieldActive" @click="resetSearchfieldValue" class="reset-btn" src="../../../assets/close-btn.png" alt="close button">

    </div>
</template>



<script>
import store from '../../../store'

export default {
    name: 'SearchfieldWithReset',
    props: {
        filterOn: String,
        filterBy: String
    },
    data () {
        return {
            searchfieldValuee: '',
        }
    },
    computed: {
        tekFilters () {
            return store.state.tekFilters
        },
        searchfieldValue: {
            get() { return this.filterOn },
            set(val) { 
                if (this.filterBy == "name") {
                    this.tekFilters.name = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
                if (this.filterBy == "email") {
                    this.tekFilters.email = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
                if (this.filterBy == "telefoonnummer") {
                    this.tekFilters.telefoonnummer = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
                if (this.filterBy == "disciplines") {
                    this.tekFilters.disciplines = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
                if (this.filterBy == "bedrijfsnaam") {
                    this.tekFilters.bedrijfsnaam = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
                if (this.filterBy == "woonplaats") {
                    this.tekFilters.woonplaats = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
                if (this.filterBy == "tekenprogramma") {
                    this.tekFilters.tekenprogramma = val
                    store.commit('updateTekFilters', this.tekFilters)
                }
            }
        },
        isSearchfieldActive () {
            if (this.searchfieldValue != "") {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        emitUpdate () {
            // $emit('tingtong', $event, 1, 2, 3, 4, "cupcakes")
            //this.filterOn = 
            //store.state.tekFilters.name = this.searchfieldValuee
        },
        resetSearchfieldValue() {
            this.searchfieldValue = ''
            //this.emitUpdate()
        }
    },

}
</script>

<style scoped>
    .searchfieldholder {
        position: relative;
        padding-right: 10px;

    }
    .reset-btn {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 8px;
        right: 18px;
        cursor: pointer;
    }
    .searchfield {
        max-width: 200px;
        width: 100%;
        height: 40px;
        background-color: #E4ECFA;
        border-radius: 100px;
        border: none;
        font-size: 14px;
        padding: 10px 10px 10px 14px;
    }
    .active {
        background-color: #3076EA;
        color: white;
    }
</style>